// ProjectTable.js
import React from 'react';
import {
  Table,
  TableContainer,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import ConfirmationDialog from 'components/sweetAlert.js/ConfirmationDialog';
import jsonData from '../../jsonData/clientProject.json'; // Adjust the path as necessary

const ProjectTable = ({ projects, onEditProject, onDeleteProject }) => {
  return (
    <TableContainer className="user-role" mt={3}>
      <Table size="md" variant="bubble" className="user-role-table">
        <Thead>
          <Tr>
            <Th>No.</Th>
            <Th width={400}>Project Name</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {projects.map((item, index) => (
            <Tr key={item._id}>
              <Td>{index + 1}</Td>
              <Td>{item.prj}</Td>
              <Td>
                <div className="d-flex">
                  <FaEdit
                    style={{ color: "#db8a2f", cursor: "pointer", marginLeft: "10px" }}
                    size={16}
                    onClick={() => onEditProject(item.prj, item._id)}
                  />
                  <AiFillDelete
                    style={{ color: 'red', cursor: "pointer", marginLeft: "10px" }}
                    size={16}
                    onClick={() => {
                      const confirmationMessage = jsonData.confirm.delete;
                      const title = confirmationMessage.replace("{projectName}", item.prj);
                        ConfirmationDialog({
                            title: title,
                            text: jsonData.text.undone,
                            icon: 'warning',
                            confirmButtonText: 'delete',
                            cancelButtonText: 'Cancel',
                            onConfirm: () => {
                                onDeleteProject(item._id);
                            },
                          });
                    }}
                  />
                </div>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default ProjectTable;